// extracted by mini-css-extract-plugin
export var column = "_tc-0";
export var divider = "_tc-2";
export var timePicker = "_tc-1";